<template>
  <div class="hc-profile-edit__footer">
    <button
      type="button"
      class="hc-profile-edit__cancel"
      :disabled="saving"
      @click="$emit('cancel')"
    >
      Cancel
    </button>
    <slot name="save">
      <button
        type="button"
        class="hc-profile-edit__save"
        :disabled="saving"
        @click="$emit('save')"
      >
        {{ saving ? savingLabel : 'Save' }}
      </button>
    </slot>
  </div>
</template>

<script>
export default {
  name: 'ProfileEditFooter',
  props: {
    saving: { type: Boolean, default: false },
    savingLabel: { type: String, default: 'Saving…' },
  },
};
</script>
